// Generated by CoffeeScript 1.11.1
(function() {
  module.exports = {
    PNG: require('./image_exports/png')
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/image_export.js
// module id = 37
// module chunks = 0